/**
 * How many of a long, unvirtualised list to draw now, and how many next (a4-13).
 *
 * Places' index is ~240 building groups — ~10,000 DOM nodes, each group an
 * `EventRow` and a picture. Drawn in one commit it was one 2–5 s task at CPU
 * x4 on Browse's Events → Places switch, nearly all of it the browser's own
 * style and layout of nodes four screens below the fold. Drawn as the first
 * screenful and then a few groups per task, nothing on screen changes and no
 * single task is long: the tail fills in behind the first paint, faster than
 * a thumb can scroll to it.
 *
 * Dependency-free, so the Worker's suite can test it.
 */

/** Groups drawn in the first commit: comfortably more than a phone screen
 *  (a group is 180–330px tall), so the first paint is never short. */
export const FIRST_DRAWN = 10

/** Groups added per later task. ~9 ms of render, commit and layout per group
 *  at CPU x4, so a step stays under the 50 ms a long task starts at. */
export const DRAW_STEP = 3

/** The next count to draw, or `null` once the list is whole. Never shrinks
 *  and never passes `total`. */
export function nextDrawn(drawn: number, total: number): number | null {
  if (drawn >= total) return null
  return Math.min(total, Math.max(drawn, FIRST_DRAWN) + DRAW_STEP)
}

/** Split a drawn count across two consecutive sections — Places' "Something
 *  on today" then the rest — so the sections draw top to bottom and each one's
 *  heading still counts its whole section. */
export function splitDrawn(drawn: number, first: number): { first: number; second: number } {
  const a = Math.min(drawn, first)
  return { first: a, second: Math.max(0, drawn - a) }
}
